import Alpine from "alpinejs";

Alpine.data("nostoSocialGallery", (initialLimit?: number, filterId?: string) => {
  return {
    filterId: filterId,
    limit: initialLimit,
    imagesLeft: [],
    imagesRight: [],
    // Utility Methods
    async fetchImages() {
      try {
        const endpoint = this.filterId
          ? `/apps/cloud/nosto/gallery?filter=${this.filterId}`
          : "/apps/cloud/nosto/gallery";

        const response = await fetch(endpoint);

        if (response.ok) {
          const data = await response.json();
          const images = data?.data?.filter((item) => item.media === "image");

          const limit = this.limit ? Number(this.limit) : 6;

          this.imagesLeft = images?.length > 3 ? (limit === 4 ? images.slice(0, 1) : images.slice(0, limit / 2)) : [];
          this.imagesRight =
            images?.length > 6 ? (limit === 4 ? images.slice(1, 4) : images.slice(limit / 2, limit)) : [];
        }
      } catch (error) {
        console.error("Error fetching images", error);
      }
    },
    // Lifecycle Hooks
    init() {
      this.fetchImages();
    },
  };
});
